// extracted by mini-css-extract-plugin
export default {"dailyCard":"dailyInfoCard_dailyCard__sIe7P"};